"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports.save = void 0;
var voyageMessageLoadShip_sidecar_1 = require("@voyage/multi/voyageMessageLoadShip-sidecar");
var voyageMessageMoney_sidecar_1 = require("@voyage/multi/voyageMessageMoney-sidecar");
var voyageMessageShipStatus_sidecar_1 = require("@voyage/multi/voyageMessageShipStatus-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var namespace = 'voyage-saver-status';
var save = function () {
    var c = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    var d = {
        money: c.money,
        oxygen: c.oxygen,
        jumpCharge: c.jumpCharge,
        power: c.power,
        shipFilename: c.shipFilename,
    };
    return d;
};
exports.save = save;
var load = function (d) {
    try {
        voyageMessageLoadShip_sidecar_1.voyageMessageLoadShip.sendMessageAndImmediatelyExecute({
            filename: d.shipFilename,
        });
        voyageMessageShipStatus_sidecar_1.voyageMessageShipStatus.sendMessageAndImmediatelyExecute({
            jump: d.jumpCharge,
            oxygen: d.oxygen,
            power: d.power,
        });
        voyageMessageMoney_sidecar_1.voyageMessageMoney.sendMessageAndImmediatelyExecute({
            money: d.money,
        });
    }
    catch (err) {
        console.log(namespace, 'load failed', err);
    }
};
exports.load = load;
